// extracted by mini-css-extract-plugin
export default {"shell":"PageMoved_shell__NSoy5","card":"PageMoved_card__Rhy3o","title":"PageMoved_title__MyYEm","message":"PageMoved_message__6D09O"};